import React, { useEffect } from "react";
import plus_icon from "../../../common/assets/images/light.png";
import { RiRefreshLine } from "react-icons/ri";
import {
  clearFilteredQueueData,
  fetchQueueList,
} from "../../../store/queueSlice";
import { Tooltip, useMediaQuery, useTheme } from "@mui/material";

import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const ConfigHeader = ({
  formData,
  setFormData,
  setSelectedPriority,
  setSelectedStatus,
  setQueueSearchTerm,
  setDisableInput,
  setCurrentQueuePage,
  setSelectedRules,
  selectedRules
}) => {
  const dispatch = useDispatch();
  const handleRefresh = () => {
    dispatch(clearFilteredQueueData());
    dispatch(fetchQueueList(1));
    setSelectedPriority("");
    setSelectedStatus("");
    setQueueSearchTerm("");
    setCurrentQueuePage(1);
    setFormData({
      queue_id: "",
      queue_name: "",
      description: "",
      priority: "",
      is_active: true,
      routing_rules: [],
      assignedCoders: [],
    });
  };
  const handleQueueAddition = () => {
    setDisableInput(false);
    setFormData({
      queue_id: "",
      queue_name: "",
      description: "",
      priority: "",
      is_active: true,
      routing_rules: [],
      assignedCoders: [],
    });
    setSelectedRules([]);
    toast.info("Fill your form now");
  };
  console.log(selectedRules,'ghfhg');
  
  const theme = useTheme();
  const ismobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);
  return (
    <div className="d-flex align-items-center justify-content-between queue-configuration-header">
      <h4 className="speciality-header-text">Speciality Queue Management</h4>
      <div className="d-flex gap-3 align-items-center">
        <Tooltip title="Refresh">
          <RiRefreshLine
            className="configuration-refresh-icon"
            style={{ cursor: "pointer" }}
            onClick={handleRefresh}
          />
        </Tooltip>
        <button className="add-queue-btn" onClick={handleQueueAddition}>
          <img src={plus_icon} alt="plus" />
          {!ismobileScreen && <span>Add New Queue</span>}
        </button>
      </div>
    </div>
  );
};

export default ConfigHeader;
